<template>
    <div>
        <vx-card class="mb-4 mt-3">
            <LimitatedPlan v-if="!planAllow('suivi-actions')" class="mb-10"/>

            <vs-row>
                <vs-col>
                
                    <h4>Suivi des actions</h4>
                    <p>Permet de suivre les actions fixées dans les campagnes d'évaluation.</p>
                </vs-col>
            </vs-row>


            <vs-row class="mt-4">
                <vs-col vs-justify="center" vs-align="center" vs-w="4">
                    <label class="typo__label">Services</label>
                    <Multiselect
                        v-model="filters.services"
                        :options="groupedServicesByEstablishments"
                        :multiple="true"
                        group-values="services"
                        group-label="establishment"
                        :group-select="true"
                        placeholder="Recherche ..."
                        track-by="id"
                        label="title"
                        select-label
                        select-group-label
                        selected-label
                        deselect-label
                        deselect-group-label
                        :loading="establishments.loading"
                        :disabled="!planAllow('suivi-actions')"
                    >
                        <span slot="noResult">Aucun résultat.</span>
                    </Multiselect>
                </vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="4">
                    <label class="typo__label">Personnes</label>
                    <Multiselect
                        v-model="filters.employees"
                        :options="groupedEmployeesByEstablishmentsAndFilteredByServices"
                        :multiple="true"
                        group-values="employees"
                        group-label="establishmentService"
                        :group-select="true"
                        placeholder="Recherche ..."
                        track-by="id"
                        label="name"
                        select-label
                        select-group-label
                        selected-label
                        deselect-label
                        deselect-group-label
                        :disabled="!planAllow('suivi-actions')"
                    >
                        <span slot="noResult">Aucun résultat.</span>
                    </Multiselect>
                </vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="4">
                    <label class="typo__label">Thèmes</label>
                    <Multiselect
                        v-model="filters.themes"
                        :options="formatedThemes"
                        :multiple="true"
                        placeholder="Recherche ..."
                        track-by="id"
                        label="name"
                        select-label
                        select-group-label
                        selected-label
                        deselect-label
                        deselect-group-label
                        :loading="themes.loading"
                        :disabled="!planAllow('suivi-actions')"
                    >
                        <span slot="noResult">Aucun résultat.</span>
                    </Multiselect>
                </vs-col>
            </vs-row>
        </vx-card>

        <!-- Action -->
        <vs-row class="mt-4">
            <vs-col vs-type="flex" vs-justify="flex-end">
                <vs-button
                    id="search-button"
                    v-if="planAllow('suivi-actions')"
                    color="primary"
                    :disabled="canSearch ? false : true"
                    @click="searchClickHandle"
                >
                    Lancer la recherche
                </vs-button>
                <div v-else style="position: relative; float: left" title="Votre formule n'inclut pas cette fonctionnalité">
                    <vs-button
                        id="search-button"
                        color="primary"
                        disabled="true"
                    >
                    Lancer la recherche
                    </vs-button>
                    <vs-icon class="button-bullet" bg="#FF9B3A" round >
                        <CrownIcon style="width: 16px; height: 16px; padding: 3px"/>
                    </vs-icon>
                </div>
            </vs-col>
        </vs-row>

        <!-- Résultat -->
        <vs-row class="mt-4">
            <vs-col vs-type="flex" vs-justify="center">
                <vs-table
                    :sst="true"
                    @search="searchStringHandle"
                    search
                    class="goals-results"
                    :data="items.data"
                    :no-data-text="`Aucune donnée à afficher`"
                    style="width: 100%"
                    :expanded="expandedChange"
                >
                    <template slot="thead">
                        <vs-th>
                            <Sort name="rating_date" @sort="sortHandle">Date de la campagne</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="due_at" @sort="sortHandle">Date de l'échéance</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="theme" @sort="sortHandle">Thème</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="label" @sort="sortHandle">Libellé de l'action</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="last_name" @sort="sortHandle">Créé par</Sort>
                        </vs-th>
                        
                        <vs-th>
                            <Sort name="establishments" @sort="sortHandle">Établissements</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="services" @sort="sortHandle">Services</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="state" @sort="sortHandle">État</Sort>
                        </vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <template v-for="(goal, gKey) in data">
                            <vs-tr>
                                <td>
                                    <feather-icon 
                                        v-if="expanded[goal.id]" 
                                        icon="ChevronUpIcon"
                                        class="expand-icon" 
                                        @click="clickExpandHandle(goal.id)" 
                                        title="Cliquer enrouler"
                                    />
                                    <feather-icon 
                                        v-else 
                                        icon="ChevronDownIcon"
                                        class="expand-icon" 
                                        @click="clickExpandHandle(goal.id)" 
                                        title="Cliquer pour dérouler"
                                    />
                                    {{ date(goal.rating_date, '/') }}
                                </td>
                                <td>
                                    {{ date(goal.due_at, '/') }}
                                </td>
                                <td>
                                    {{ goal.theme }}
                                </td>
                                <td>
                                    <ms-chip color="rgb(220, 220, 220)">
                                        <b>{{ goal.label }}</b>
                                    </ms-chip>
                                </td>
                                <td>
                                    {{ goal.last_name }} {{ goal.first_name }}
                                </td>
                                <td>
                                    {{ goal.establishments }}
                                </td>
                                <td>
                                    {{ goal.services }}
                                </td>
                                <td>
                                    <div class="examplex">
                                        <vs-button class="btnx" type="filled" :color="getColorFor('goal_status', goal.state)" :style="'color: '+getColorFor('goal_status_text', goal.state)+' !important;'">{{ states.data.find(s => s.id === goal.state).name }}</vs-button>
                                        <vs-dropdown>
                                            <vs-button class="btn-drop" type="filled" :color="getColorFor('goal_status', goal.state)" icon="expand_more" :style="'color: '+getColorFor('goal_status_text', goal.state)+' !important;'"></vs-button>
                                            <vs-dropdown-menu>
                                                <vs-dropdown-item :key="index" :text="item.name" v-for="(item,index) in states.data">
                                                    <div @click="stateChangeHandle(goal, item.id)">{{ item.name }}</div>
                                                </vs-dropdown-item>
                                            </vs-dropdown-menu>
                                        </vs-dropdown>
                                    </div>
                                </td>
                            </vs-tr>
                            <vs-tr v-if="expanded[goal.id]">
                                <vs-td colspan="8">
                                    <vs-textarea v-model="goal.means" label="Moyen à mettre en oeuvre" disabled="true"/>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </template>
                </vs-table>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col class="mt-4" v-if="items.total > 0">
                <vs-pagination :total="Math.ceil(items.total / perpage)" v-model="currentPage"></vs-pagination>
            </vs-col>
        </vs-row>
    </div>
</template>


<script>
import Multiselect from "vue-multiselect";
import { formatDate as date } from "@assets/utils/helpers/helpers.js";
import LimitatedPlan from '@components/divers/LimitatedPlan';
import CrownIcon from '@components/svg/CrownIcon';

export default {
    name: "Goals",
    components: {
        Multiselect, CrownIcon, LimitatedPlan
    },
    props: {},
    data() {
        return {
            log: console.log,
            date,
            currentPage: 1,
            perpage: 10,
            employees: {
                data: [],
                loading: false
            },
            establishments: {
                data: [],
                loading: false
            },
            themes: {
                data: [],
                loading: false
            },
            states: {
                data: [],
                loading: false
            },
            filters: {
                services: [],
                employees: [],
                themes: []
            },
            items: {
                data: [],
                loading: false,
                params: {
                    search: null,
                    sortBy: {}
                },
                total: 0,
            },
            expanded: {},
            expandedChange: 0
        }
    },
    created() {
        const start_at = Date.now();

        if(this.planAllow('suivi-actions')) {
            Promise.all([
                this.loadEmployees(),
                this.loadEstablishments(),
                this.loadThemes(),
                this.loadStates()
            ]).then(() => {
                console.log(`Chargement des listes +${Date.now() - start_at}ms`)
            })
        }
        
    },
    watch: {
        filters: {
            handler(value) {
                this.items.data = [];
            }, deep: true
        }
    },
    computed: {
        canSearch() {
            return this.filters.services.length || this.filters.employees.length;
        },
        groupedServicesByEstablishments() {
            let toShow = [];
            let establishments = this.filterEstablishmentFormViewableService(this.establishments.data);

            establishments.forEach(e => {
                toShow.push({
                    establishment: e.name,
                    services: this.services ? this.services.filter(service =>
                                    service.establishment_id === e.id &&
                                    this.listOfServicesViewableFor("employees").includes(service.id))
                                : []
                });
            });
            return toShow;
        },
        groupedEmployeesByEstablishments() {
            let toShow = [];
            let establishments = this.establishments.data;

            if (this.filters.services.length > 0) {

            }

            establishments.forEach(e => {
                toShow.push({
                    establishment: e.name,
                    employees: this.employees.data ? this.employees.data.filter(employee =>
                            employee.services.length &&
                            employee.services?.map(s => s.establishment_id)
                            .includes(e.id) && this.listOfServicesViewableFor("employees")
                        )
                        .map(employee => {
                            return {
                                ...employee,
                                name: `${employee.last_name.toUpperCase()} ${employee.first_name}`
                            };
                        })
                        : []
                });
            });

            return toShow;
        },
        formatedThemes() {
            return this.themes.data.map(t => {
                return { id: t, name: t }
            })
        },

        groupedEmployeesByEstablishmentsAndFilteredByServices() {
            let toShow = [];

            const establishments = this.filterEstablishmentFormViewableService(this.establishments.data);

            establishments.forEach(establishment => {

                establishment.services.forEach(service => {

                    // Nom du groupe (etablissement / service)
                    const groupName = `${establishment.name} / ${service.title}`;

                    const filteredEmployees = this.employees.data.filter(e =>
                        e.services.length &&
                        e.services?.map(s => s.establishment_id).includes(establishment.id) &&
                        e.services.map(s => s.id).includes(service.id)
                    );

                    toShow.push({
                        establishmentService: groupName,
                        employees: filteredEmployees.map(employee => {
                            return {
                                ...employee,
                                name: `${employee.last_name.toUpperCase()} ${employee.first_name}`
                            };
                        })
                    });
                })
            });

            if (this.filters.services.length > 0) {
                const establishmentServiceNames = this.filters.services.map(s => `${s.establishment.name} / ${s.title}`);

                // Personne des services filtrés, en 1er
                toShow = toShow.sort((a, b) => establishmentServiceNames.includes(a.establishmentService) ? -1 : 1);
            }

            return toShow;
        },
    },
    methods: {
        async loadEstablishments() {
            this.establishments.loading = true;

            return window
                .axios({
                    method: "get",
                    url: "/api/referentiel/establishments",
                    params: {
                        perpage: 9999,
                        include: ['services']
                    }
                })
                .then(response => {
                    this.establishments.data = response.data.data;
                    this.establishments.loading = false
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },
        async loadEmployees() {
            this.employees.loading = true;
            
            return window
                .axios({
                    method: "get",
                    url: "/api/gestion/employees",
                    params: { perpage: 9999, include: ['services.establishment', 'currentJobs', 'currentOccupations'] }
                })
                .then(response => {
                    this.employees.data = response.data.data;
                    this.employees.loading = false
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        async loadThemes() {
            this.themes.data = [
                'Plan',
                'Do',
                'Check',
                'Act'
            ];
        },

        async loadStates() {
            this.states.data = [
                {
                    id: 1,
                    name: 'Non commencé'
                },
                {
                    id: 2,
                    name: 'En cours',
                },
                {
                    id: 3,
                    name: 'Terminé',
                },
                {
                    id: 4,
                    name: 'Validé',
                }
            ];
        },

        getEmployeeById(id) {
            return this.employees.data.find(e => e.id === id);
        },
        
        searchClickHandle() {
            this.search = null;
            this.sortBy = null;
            this.loadItems();
        },

        searchStringHandle(search) {
            this.items.params.search = search;
            this.loadItems();
        },

        sortHandle(sort, direction) {
            this.items.params.sortBy[sort] = direction;
            this.loadItems();
        },

        loadItems() {
            this.items.loading = true;

            this.items.data = [
                {
                    id: 1,
                    rating_date: '2024/09/01',
                    due_at: null,
                    theme: 'Plan',
                    label: 'Action 1',
                    first_name: 'Léa',
                    last_name: 'Bordière',
                    establishments: 'ECN - Enseignants',
                    services: 'Mathématiques - Responsable matière',
                    state: 2,
                    means: 'Aucun',
                    employee: {}
                },
                {
                    id: 2,
                    rating_date: '2025/05/27',
                    due_at: null,
                    theme: 'Do',
                    label: 'Action 2',
                    first_name: 'Daisy',
                    last_name: 'DAY',
                    establishments: 'ECN - Enseignants',
                    services: 'Mathématiques',
                    state: 1,
                    means: '',
                    employee: {}
                },
                {
                    id: 3,
                    rating_date: '2025/05/27',
                    due_at: null,
                    theme: 'Check',
                    label: 'Action 3',
                    first_name: 'Daisy',
                    last_name: 'DAY',
                    establishments: 'ECN - Enseignants',
                    services: 'Physiques',
                    state: 1,
                    means: '',
                    employee: {}
                },
                {
                    id: 4,
                    rating_date: '2025/05/27',
                    due_at: null,
                    theme: 'Act',
                    label: 'Action 4',
                    first_name: 'Daisy',
                    last_name: 'DAY',
                    establishments: 'ECN - Enseignants',
                    services: 'Anglais - Responsable matière',
                    state: 2,
                    means: '',
                    employee: {}
                },
            ]
        },

        stateChangeHandle(goal, stateValue) {

            window
                .axios({
                    method: "patch",
                    url: `/api/gestion/employees/-1/ratings/goals/state/${stateValue}`,
                    data: {...goal}
                })
                .then(response => {
                    this.loadItems()
                    this.notifySuccess('Succès', 'État mis à jour avec succès !')
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        clickExpandHandle(id) {
            this.expanded[id] = this.expanded[id] ? false : true
            this.expandedChange++;
        },
    }
}
</script>
<style lang="scss">
.examplex {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
        margin: 0 !important;

        &.btnx {
            margin-left: 10px !important;
            border-radius: 5px 0 0 5px;
            height: 20px !important;

            span.vs-button--text {
                top: -5px !important;
            }
        }

        &.btn-drop {
            border-radius: 0 5px 5px 0;
            border-left: 1px solid rgba(255, 255, 255, .2);
            padding: 0 !important;
            margin: 0 !important;
            width: 20px !important;
            height: 20px !important;
        }
    }
}
::v-deep .vs-button--text {
    top: -5px !important;
}
</style>